import React, { useEffect, useCallback } from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import addFont from '../../../assets/fonts/fonts';
import styles from './styles.module.css';
import { 
  grantAdjunctNames, 
  grantAdjunctNamesActive, 
  grantMiddleNames, 
  grantMiddleNamesActive, 
  grantNames, 
  grantNamesActive
} from '../../../utils/const';
import moment from 'moment';

export const optionsNames = {
  "Курсант": 'Специалитет',
  "Слушатель": "Магистратура",
  "Адъюнкт": "Адъюнктура",
  "СПО": "СПО"
}

const getOptions = (scholarship_type, name) => {
  if (name === 'scholarship_secondary_education') {
    return scholarship_type == null ? grantMiddleNames : grantMiddleNamesActive;
  } 
  if (name === 'scholarship_higher_education_adjunct') {
    return scholarship_type == null ? grantAdjunctNames : grantAdjunctNamesActive;
  }
  return scholarship_type == null ? grantNames : grantNamesActive;
};

const getDate = (options_, opt) => {
  const date = options_?.find((el) => 
    opt?.prep_struc_category_id === el.prep_struc_category_id && 
    opt.education_level === el.education_level);
  
  const from = moment(date?.date_from).format('DD.MM.YYYY');
  const to = moment(date?.date_to).format('DD.MM.YYYY');
  return `с ${from} по ${to}`;
};

const PdfPrint = ({ 
  candidatslist, 
  data, 
  year, 
  tableNames, 
  chief, 
  GOU, 
  yearsLocal, 
  options, 
  heads, 
  setHeads,
  checkMarks 
}) => {
  const { data: options_, education_levels } = options;

  addFont(jsPDF.API);

  const createDocData = useCallback(() => {
    let lastY = 52;

    const getY = (indent, newValue) => {
      let newY = newValue ? newValue + indent : lastY + indent;
      if (newY > doc.internal.pageSize.height - 20) {
        doc.addPage("a3", "landscape"); // Новая страница A3
        newY = 10;
      }
      lastY = newY;
      return newY;
    };

    // Создаем документ A3 в альбомной ориентации
    const doc = new jsPDF({
      orientation: "l",
      unit: "mm",
      format: "a3",
    });
    doc.setFont("TimesNewRoman").setFontSize(14);

    // Заголовки (выравнивание по правому краю A3)
    if (heads[0].post && heads[0].name && heads[0].rank ) {
      let len1 = (doc.getTextDimensions(`${`${heads[0].rank}                           ${heads[0].name}`}`).w);
      let len2 = (doc.getTextDimensions(`${`${heads[0].post}`}`).w);
      let getMaxLen = Math.max(len1, len2);
      doc.text("УТВЕРЖДАЮ", doc.internal.pageSize.width - 9 - (getMaxLen) / 2, 10, { align: "center" });
      doc.text(`${heads[0].post}`, doc.internal.pageSize.width - 9 - (getMaxLen) / 2, 17, { align: "center" });
      doc.text(
        `${heads[0].rank}                           ${heads[0].name}`,
        doc.internal.pageSize.width - 9 - (getMaxLen) / 2,
        24,
        { align: "center" }
      );
      doc.text(
        `${heads[0].date ? moment(heads[0].date || null).format("D MMMM YYYY г.") : ''}`,
        doc.internal.pageSize.width - 9 - (getMaxLen),
        31,
        { align: "left" }
      );
    }
    // Основной текст (центрирование по A3)
    doc.setFontSize(14);
    doc.text(
      "Список кандидатов на стипендии Президента Российской Федерации, Правительства Российской Федерации",
      doc.internal.pageSize.width / 2,
      38,
      { align: "center" }
    );
    doc.text(
      "и Министерства обороны Российской Федерации",
      doc.internal.pageSize.width / 2,
      45,
      { align: "center" }
    );
    doc.text(
      `На ${yearsLocal} учебный год`,
      doc.internal.pageSize.width / 2,
      52,
      { align: "center" }
    );

    // Таблица (подстраивается под A3)
    doc.autoTable({
      html: `#gradeDescriptionTable`,
      styles: {
        font: "TimesNewRoman",
        fontSize: 8,
        cellPadding: 1,
        textColor: [0, 0, 0],
        lineColor: [0, 0, 0],
        lineWidth: 0.2,
        halign: "center",
        valign: "middle",
      },
      pageBreak: "auto",
      didParseCell: (data) => {
        data.cell.styles.fillColor = [255, 255, 255];
      },
      startY: getY(15),
      columnStyles: {
        columnWidth: "wrap",
        [18]: {
          columnWidth: 35,
          halign: "center",
        },
      },
    });
    // Подписи и даты
    const currentY = doc.lastAutoTable.finalY || getY(13);
    
    if (heads[1].post && heads[1].name && heads[1].rank ) {
    doc.text(`${heads[1].post}`, 200, currentY + 20, { align: "center" });
    // doc.text(`${heads[1].rank}`, doc.getTextDimensions(heads[1].post).w, currentY + 25, { align: "left" });
    doc.text(`${heads[1].rank}           ${heads[1].name}`, 200, currentY + 27, { align: "center" });

    doc.text(
      `${moment().format("D MMMM YYYY г.")}`,
      150,
      currentY + 34,
      { align: "left" }
    );
    }
    // Периоды (нижний колонтитул)
    doc.setFontSize(12);

    education_levels &&
      education_levels.map((opt, i) => {
        if (i === 0) doc.text('Учитываются достижения за следующие периоды', 10, currentY + 45, {
          align: "left",
        });
        doc.text(`${optionsNames?.[opt?.prep_struc_category]} ${getDate(options_, opt)}`, 10, currentY + 50 + i * 5, {
          align: "left",
        });
      });

    return doc;
  }, [heads, education_levels, options_, yearsLocal]);

  const toPdf = useCallback(() => {
    const doc = createDocData();
    doc.save(`Отчет_${yearsLocal}.pdf`);
    setHeads([]);
  }, [createDocData, setHeads, yearsLocal]);

  useEffect(() => {
    if (heads[0]?.type === 'report' && heads[0]?.done) {
      toPdf();
    }
  }, [heads, toPdf]);

  const handlePdf = useCallback(() => {
    setHeads([
      {
        id: 1,
        title: 'Утверждает',
        name: '',
        rank: '',
        post: '',
        date: '',
        type: 'report'
      },
      {
        id: 2,
        title: 'Подписант',
        name: '',
        rank: '',
        post: '',
        date: '',
        type: 'report'
      }
    ]);
  }, [setHeads]);

  return (
    <>
      <button onClick={handlePdf} type='button' className={styles.button}>Отчет для ученого совета</button>
      <table id='gradeDescriptionTable' hidden>
        <thead>
          <tr>
            <th colSpan={
                8 
                + candidatslist?.columns_honours
                ?.filter((el_) => el_?.parent_id == 150)?.length
                }></th>
              <th colSpan={candidatslist?.columns_honours
                  ?.filter((el_) => el_?.parent_id == 150)?.length || 1}>
                  {
                      candidatslist?.columns_honours
                          ?.find((el_) => el_?.previous_level_id == 150)
                          .previous_level_title
                  }
              </th>
              <th colSpan={5}></th>
          </tr>
          <tr> 
              <th>№п/п</th>
              <th>В/зв</th>
              <th>ФИО</th>
              <th>Должность</th>
              <th>Номер группы</th>
              <th>Курс обучения</th>
              <th>Средний балл</th>
              <th>Кол-во и процент "отлично"</th>
              <th>Кол-во и процент "хорошо"</th>
              {candidatslist?.columns_honours
              ?.filter((el_) => el_.previous_level_id != 150)
              ?.map((el) => (
                  <th key={el.id}>{el.previous_level_title || 'Пусто'}</th>
              ))}
              <th className={styles.table__title}>Суммарный коэффициент достижений</th>
              <th>Текущая успеваемость</th>
              <th id="honours">Претендует{'\u00A0'}на{'\u00A0'}назначение следующего вида стипендии или Исключению из списка</th>
          </tr>
        </thead>
        <tbody>
          {data && year != '0' && data?.map((arr, i) => (
            <React.Fragment key={`group-${i}`}>
              <tr>
                <td colSpan={100}>{tableNames?.[arr[0]]}</td>
              </tr>
              {arr[1]?.length > 0 ? (
                arr[1]
                  .sort((a, b) => b.average_grade - a.average_grade)
                  .map((el, i) => (
                    <tr key={el.mid}>
                      <td>{i + 1}</td>
                      <td>{el.militaryrank}</td>
                      <td>{el.student_name}</td>
                      <td>{el.prep_struc_category}</td>
                      <td>{el.group_name}</td>
                      <td>{el.yeducationyear}</td>
                      <td>{el.average_grade}</td>
                      <td>{el.five_count} / {el.five_percentage.toFixed(0)}%</td>
                      <td>{el.four_count} / {el.four_percentage.toFixed(0)}%</td>
                      {candidatslist
                      ?.columns_honours
                      ?.filter(el_ => el_?.parent_id != 150)
                      .map((_el, _i) => {
                          if (_el.previous_level_id == 150) {
                              let dd = el?.third_level_data?.find(__el => __el.previous_level_id === 150) || {
                                  data: [
                                      { last_level_count: 0, last_level_points: 0 },
                                      { last_level_count: 0, last_level_points: 0 },
                                      { last_level_count: 0, last_level_points: 0 }
                                  ]
                              }; ;
                              let item = {data: [
                                  dd?.data?.find(__el => __el.previous_level_id === 151) || {last_level_count: 0, last_level_points: 0}, 
                                  dd?.data?.find(__el => __el.previous_level_id === 152) || {last_level_count: 0, last_level_points: 0}, 
                                  dd?.data?.find(__el => __el.previous_level_id === 153) || {last_level_count: 0, last_level_points: 0}, 
                              ] }
                              
                              
                              return item?.data?.map((elem, i_elem) => {
                                  const count = elem?.last_level_count || 0;
                                  const coeff = elem?.last_level_points || 0;
                                  const value = `${count} / ${coeff}`;
                                  return <td key={i_elem}>{value}</td>;
                              });
                          } else {
                              const item = el?.third_level_data?.find(__el => __el.previous_level_id === _el.previous_level_id);
                              const count = item?.last_level_count || 0;
                              const coeff = item?.last_level_points || 0;
                              const value = `${count} / ${coeff}`;
                              return <td key={_i}>{value}</td>;
                          }
                      })
                      }
                      <td>{el.record_points || 0}</td>
                      <td>{el.current_avg_grade || 0}</td>
                      <td>
                        <div>
                          {
                            el.grants?.length > 0 ? (
                              el.grants
                              // ?.filter(_el => { 
                              //     if (el.average_grade != 5) {
                              //     return _el.label && _el.label !== 'Министерства обороны РФ';
                              //     } else {
                              //         return true;
                              //     }
                              // })
                              ?.map((_el, _i) => (
                                `${_el.scholarship_type} `
                              ))
                            ) : (
                              checkMarks(el.prep_struc_category, tableNames?.[arr[0]], el.average_grade, getOptions(el.scholarship_type, arr[0]))
                              ?.map((_el, _i) => (
                                `${_el.label} `  
                              ))
                            )
                          }
                        </div>
                      </td>
                    </tr>
                  ))
              ) : (
                <tr>
                  <td colSpan={100}>Нет данных</td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default PdfPrint;